<template>
  <section class="search-container">
    <div class="search-header">
      <div class="search-input-wrapper">
        <form @submit.prevent="() => false" action="javascript:return true;" class="input-form">
          <md-input-item
            ref="inputSearch"
            type="search"
            :placeholder="$route.params.type === 'knowledge' ? '输入关键字搜索' : '输入关键字或商品链接、口令'"
            :maxlength="200"
            v-model="searchText"
            @focus="inputFocus"
            @keyup.native.enter="onSearchSubmit">
            <a href="javascript:;" class="clear-btn" slot="right" v-if="searchText" @click="handleClearSearchText">
              <md-icon name="clear"></md-icon>
            </a>
          </md-input-item>
        </form>
        <a href="javascript:;" class="cancel" @click="handleCancel">取消</a>
      </div>
    </div>
    <template v-if="!isShowHis">
      <template v-if="$route.params.type === 'knowledge'">
        <KnowledgeSearchList ref="KnowledgeSearchList" :searchText="searchText" />
      </template>
      <template v-else>
        <PhysicalSearchList ref="PhysicalSearchList" :searchText="searchText" />
      </template>
    </template>
    <template v-else>
      <History :visible="isShowHis" ref="historyList" @searchHis="handleHisSearch" />
    </template>
  </section>
</template>

<script>
import History from "./components/history";
import KnowledgeSearchList from "./components/knowledgeSearchList";
import PhysicalSearchList from "./components/physicalSearchList";

export default {
  data() {
    return {
      searchText: "",
      isShowHis: true,
      searchTag: {
        Knowledge: [{
          tag: '202105',
          value: '5月'
        }]
      }
    };
  },
  components: {
    History,
    KnowledgeSearchList,
    PhysicalSearchList
  },
  methods: {
    //搜索数据
    load() {
      this.$nextTick(()=>{
        if(this.$route.params.type === 'knowledge') {
          this.$refs.KnowledgeSearchList.load()
        }else{
          this.$refs.PhysicalSearchList.load();
        }
      })
    },
    //通过输入框 输入关键字
    onSearchSubmit(name, event) {
      if (!this.searchText) {
        this.$toast.info('请输入关键字搜索')
        return;
      }
      this.$refs.historyList.addToHistory(this.searchText);
      this.$refs.inputSearch.blur();
      this.isShowHis = false;

      this.load()
    },
    //通过点击历史搜索标签 搜索
    handleHisSearch(text) {
      this.searchText = text;
      this.isShowHis = false;
      
      this.load()
    },
    // input focus
    inputFocus() {
      this.isShowHis = true;
    },
    // 地址携带tag处理
    handleQueryTag() {
      const tagItem = this.searchTag.Knowledge.filter(item => this.$route.query.tag === item.tag)[0]
      if(tagItem) {
        this.searchText = `tag:${tagItem.value}`
      } 
      this.$refs.inputSearch.blur();
      this.onSearchSubmit()
    },
    // 清空搜索条件
    handleClearSearchText() {
      this.searchText = "";
      this.inputFocus();
    },
    //取消
    handleCancel() {
      this.$router.go(-1)
    }
  },
  created() {
    document.title = this.$route.params.type === 'knowledge' ? '搜索知识分销' : '搜索实物分销' 
  },
  mounted() {
    this.$refs.inputSearch.focus();
    this.handleQueryTag()
  }
};
</script>

<style lang="scss">
$search-input-height: 64px;
.search-container {
  padding-top: 124px;
  position: relative;

  .search-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    background-color: #fff;
  }
  .search-input-wrapper {
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 124px;
    flex-wrap: nowrap;

    .input-form{
      flex: 1;
      margin-right: 28px;
    }
    .md-field-item-content{
      min-height: $search-input-height;

      &::before{
        border: none;
      }
    }
    .md-input-item{
      border: 1px solid #E1E1E6;
      transition: all .3s;
      border-radius: $search-input-height;
      
      &.is-active,.is-focus{
        border: 1px solid $primary-color;
      }
    }
    .md-input-item-input{
      height: $search-input-height;
      font-size: 24px;
      padding: 0 50px 0 32px;
      line-height: 1;
    }
    .md-field-item-right{
      margin-left: 0;
      margin-right: 16px;
    }
    .clear-btn{
      color: #858b9c;
    }
    .cancel {
      color: #636666
    }
  }
}
</style>